<kal-form-field class="gup-C-formFieldSize--bottomNull without-label">

    <ng-container [ngSwitch]="dataType">

        <kal-input *ngSwitchCase="DataTypes.Text"
                   [formControl]="control"></kal-input>

        <kal-input *ngSwitchCase="DataTypes.Number"
                   [formControl]="control"
                   type="number"
                   defaultValue=""></kal-input>

        <kal-input *ngSwitchCase="DataTypes.Integer"
                   [formControl]="control"
                   type="number"
                   defaultValue=""></kal-input>

        <kal-datepicker *ngSwitchCase="DataTypes.Date"
                        [formControl]="control"></kal-datepicker>

        <kal-select *ngSwitchCase="DataTypes.List"
                    [formControl]="control">

            <kal-option *ngFor="let value of availableValues" [value]="value.Id">
                {{value.Valeur}}
            </kal-option>

        </kal-select>

        <kal-checkbox *ngSwitchCase="DataTypes.Boolean"
                      [formControl]="control"
                      kalTheme="switch">
        </kal-checkbox>

    </ng-container>

</kal-form-field>
